import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { formatText } from "util/helper";
import ParentNavItemListMobile from "./ParentNavItemListMobile";
import SingleNavMenuMobile from "./SingleNavMenuMobile";
import classes from "./NavItemsMobile.module.css";

const NavItemsMobile = ({
  navMenuItemOrderIdList,
  navMenuItemList,
  setNavOpen,
  showModalsHandler,
  modalContents,
  LangSelect,
}) => {
  return (
    <div className={classes["mobile-nav--contents"]}>
      {navMenuItemOrderIdList
        ? navMenuItemOrderIdList.map(navMenuItemOrderId => {
            if (navMenuItemList[navMenuItemOrderId].children.length < 1) {
              return (
                <SingleNavMenuMobile
                  key={navMenuItemOrderId}
                  item={navMenuItemList[navMenuItemOrderId]}
                  setNavOpen={setNavOpen}
                />
              );
            } else {
              return (
                <ParentNavItemListMobile
                  key={navMenuItemOrderId}
                  item={navMenuItemList[navMenuItemOrderId]}
                  showModalsHandler={showModalsHandler}
                  modalContents={modalContents}
                  setNavOpen={setNavOpen}
                />
              );
            }
          })
        : null}
      <div className={classes["lang-select"]}>
        <LangSelect />
      </div>

      <Link
        to="/signup"
        className={classes.signup}
        onClick={() => setNavOpen(false)}
      >
        <FormattedMessage id={formatText("sign_up")} />
      </Link>

      <div className={classes["request-button"]}>
        <Link
          to="/request-a-demo"
          className={`${classes["custom-button"]} green-button`}
          onClick={() => setNavOpen(false)}
        >
          <FormattedMessage id={formatText("request_a_demo")} />
        </Link>
      </div>
    </div>
  );
};

export default NavItemsMobile;
